import type { RouteObject } from 'react-router-dom';
import { Outlet } from 'react-router-dom';
import NotFound from '@/pages/NotFound';
import Dashboard from '@/pages/dashboard/page';
import Placeholder from '@/pages/Placeholder';
import AppLayout from '@/components/feature/AppLayout';
import BugununIsleri from '@/pages/todays-jobs/page';
import AktifIsler from '@/pages/active-jobs/page';
import TamamlananIsler from '@/pages/completed-jobs/page';
import Musteriler from '@/pages/customers/page';
import Takip from '@/pages/follow-up/page';
import Tahsilatlar from '@/pages/payments/page';
import Finans from '@/pages/finance/page';
import Ekipler from '@/pages/teams/page';
import Raporlar from '@/pages/reports/page';
import Ayarlar from '@/pages/settings/page';

function DashboardLayout() {
  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
}

const routes: RouteObject[] = [
  {
    element: <DashboardLayout />,
    children: [
      { path: '/', element: <Dashboard /> },
      { path: '/bugunun-isleri', element: <BugununIsleri /> },
      { path: '/teklif-talepleri', element: <Placeholder title="Teklif Talepleri" icon="ri-file-list-3-line" /> },
      { path: '/teklifler', element: <Placeholder title="Teklifler" icon="ri-file-text-line" /> },
      { path: '/randevu', element: <Placeholder title="Randevu & Takvim" icon="ri-calendar-line" /> },
      { path: '/aktif-isler', element: <AktifIsler /> },
      { path: '/musteriler', element: <Musteriler /> },
      { path: '/takip', element: <Takip /> },
      { path: '/tamamlanan-isler', element: <TamamlananIsler /> },
      { path: '/tahsilatlar', element: <Tahsilatlar /> },
      { path: '/finans', element: <Finans /> },
      { path: '/ekipler', element: <Ekipler /> },
      { path: '/raporlar', element: <Raporlar /> },
      { path: '/ayarlar', element: <Ayarlar /> },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;